import './fontawesome';

$(() => {
    const smBreakpoint = window.matchMedia('(max-width: 600px)');

    const handleAccordionClick = (click) => {
        const $target = $(click.currentTarget);
        $target.find('.fas').toggleClass('fa-rotate-180');
        $target.next('[data-accordion="target"]').slideToggle('slow');
    };

    const changeAccordion = () => {
        // Always unbind first to prevent accumulating handlers
        $('[data-accordion="toggle"]').off('click', handleAccordionClick);

        if (smBreakpoint.matches) {
            $('[data-accordion="toggle"] ~ [data-accordion="target"]').hide();
            $('[data-accordion="toggle"]').on('click', handleAccordionClick);
        } else {
            $('[data-accordion="toggle"] ~ [data-accordion="target"]').show();
        }
    };

    smBreakpoint.addEventListener('change', changeAccordion);
    changeAccordion();

    jQuery(document).on('relevanssi_live_search_start', () => {
        relevanssi_live_search_params.ajaxurl = '/wp-json/bv/v1/search';
    });
});
